const ComprehensiveValues = {
    NO_COVERAGE: 'no',
    FIVE_HUNDRED: '500',
    ONE_THOUSAND: '1000',
};

export default ComprehensiveValues;
